import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import "./css/DailyMenu.css"

const DailyMenu = ({
    dailyMenuItems,
    handleAddDailyMenu,
    editingItemId,
    tempDailyMenuItem,
    setTempDailyMenuItem,
    handleUpdateDailyMenuItem,
    handleCloseEdit,
    handleEditDailyMenuItem,
    handleDeleteDailyMenuItem,
    showMenuTable,
    menuItems,
    addedDailyMenuItems,
    selectedItem,
    dailyMenuItem,
    handleDailyMenuChange,
    handleAddDailyMenuItem,
    handleClose,
    handleSelectItem
}) => {
    return (
        <div className="daily-menu-content daily-menu">

            <h3>Daily Menu</h3>
            <button className="add-menu-button" onClick={handleAddDailyMenu}>
                Add Daily Menu
            </button>

            {/* Render daily menu items in a table format */}
            {dailyMenuItems.length > 0 ? (
                <table className="menu-table">
                    <thead>
                        <tr>
                            <th>Food Type</th>
                            <th>Food Item</th>
                            <th>Meal</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Notes</th>
                            <th>Ingredients</th>
                            <th>Availability</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dailyMenuItems.map((item) => (
                            <tr key={item.Daily_Item_Id}>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Food_Type}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Food_Type: e.target.value })}
                                        />
                                    ) : (
                                        item.Food_Type
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Food_Item}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Food_Item: e.target.value })}
                                        />
                                    ) : (
                                        item.Food_Item
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Meal}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Meal: e.target.value })}
                                        />
                                    ) : (
                                        item.Meal
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Price}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Price: e.target.value })}
                                        />
                                    ) : (
                                        item.Price
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Quantity}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Quantity: e.target.value })}
                                        />
                                    ) : (
                                        item.Quantity
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Notes}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Notes: e.target.value })}
                                        />
                                    ) : (
                                        item.Notes
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="text"
                                            value={tempDailyMenuItem.Ingredients}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, Ingredients: e.target.value })}
                                        />
                                    ) : (
                                        item.Ingredients
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <input
                                            type="number"
                                            value={tempDailyMenuItem.No_of_items_available}
                                            onChange={(e) => setTempDailyMenuItem({ ...tempDailyMenuItem, No_of_items_available: e.target.value })}
                                        />
                                    ) : (
                                        item.No_of_items_available || 'N/A'
                                    )}
                                </td>
                                <td>
                                    {editingItemId === item.Daily_Item_Id ? (
                                        <>
                                            <button onClick={() => handleUpdateDailyMenuItem(item.Daily_Item_Id)}>
                                                Update
                                            </button>
                                            <button className="close-button" onClick={handleCloseEdit}>
                                                Close
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="edit-button" onClick={() => handleEditDailyMenuItem(item.Daily_Item_Id)}>
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button className="delete-button" onClick={() => handleDeleteDailyMenuItem(item.Daily_Item_Id)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No daily menu items available.</p>
            )}

            {showMenuTable && (
                <table className="menu-table">
                    <thead>
                        <tr>
                            <th>Food Type</th>
                            <th>Food Item</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Notes</th>
                            <th>Ingredients</th>
                            <th>Availability</th>
                            <th>Meal</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(menuItems).map((foodType) =>
                            menuItems[foodType]
                                .sort((a, b) => a.Food_Item_Id - b.Food_Item_Id) // Sort items by ID (ascending)
                                .map((item) => (
                                    <tr key={item.Food_Item_Id} className={addedDailyMenuItems.includes(item.Food_Item_Id) ? 'added-row' : ''}>
                                        {selectedItem === item.Food_Item_Id ? (
                                            <>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="foodType"
                                                        value={dailyMenuItem.foodType}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="foodItem"
                                                        value={dailyMenuItem.foodItem}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="price"
                                                        value={dailyMenuItem.price}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="quantity"
                                                        value={dailyMenuItem.quantity}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="notes"
                                                        value={dailyMenuItem.notes}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="ingredients"
                                                        value={dailyMenuItem.ingredients}
                                                        onChange={handleDailyMenuChange}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="No_of_items_available" // Availability input
                                                        value={dailyMenuItem.no_of_items_available}
                                                        onChange={handleDailyMenuChange}
                                                        placeholder="Enter availability"
                                                    />
                                                </td>
                                                <td>
                                                    <select
                                                        name="meal"
                                                        value={dailyMenuItem.meal}
                                                        onChange={handleDailyMenuChange}
                                                    >
                                                        <option value="">Select Meal</option>
                                                        <option value="Breakfast">Breakfast</option>
                                                        <option value="Lunch">Lunch</option>
                                                        <option value="Dinner">Dinner</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <button
                                                        className="add-button"
                                                        onClick={(e) => handleAddDailyMenuItem(e, item.Food_Item_Id)}
                                                    >
                                                        Add
                                                    </button>
                                                    <button className="close-button" onClick={handleClose}>
                                                        Close
                                                    </button>
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td>{item.Food_Type}</td>
                                                <td>{item.Food_Item}</td>
                                                <td>{item.Price}</td>
                                                <td>{item.Quantity}</td>
                                                <td>{item.Notes}</td>
                                                <td>{item.Ingredients}</td>
                                                <td>{item.No_of_items_available || 'N/A'}</td> 
                                                <td>{item.Meal || 'N/A'}</td>
                                                <td>
                                                    <button onClick={() => handleSelectItem(item.Food_Item_Id)}>
                                                        Select
                                                    </button>
                                                </td>
                                            </>
                                        )}
                                    </tr>
                                ))
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default DailyMenu;
